import { Card, Flex, Typography } from "antd"
import loader from '../../assets/loader.gif'
import { CSSProperties, ReactNode } from "react"

export type LoadingCardProps = {
    title: string,
    content?: string,
    alt: string,
    cardStyle?: CSSProperties,
    children?: ReactNode[],
}
export const LoadingCard = ({
    title,
    content,
    alt,
    children,
    cardStyle = {}
}: LoadingCardProps) => <><Card
    style={Object.assign({
        height: '300px',
        width: '430px',
        borderRadius: '24px'
    }, cardStyle)}
    bodyStyle={{ height: '100%' }}
>
    <Flex
        align="center"
        justify='center'
        vertical
        gap='16px'
        style={{ height: '100%' }}
    >
        <img
            src={loader}
            alt={alt}
            height='150px'
            width='150px'
        />
        <div style={{ textAlign: 'center' }}>
            <Typography.Text
                style={{
                    fontSize: '16px',
                    lineHeight: '24px',
                    fontWeight: '600'
                }}
            >
                {title}
            </Typography.Text>
            <br/>
            <Typography.Text
                type="secondary"
                style={{
                    fontSize: '14px',
                    lineHeight: '22px',
                    fontWeight: '400'
                }}
            >
                {content}
            </Typography.Text>
        </div>
    </Flex>
</Card>
{children}
</>
